import { mapFields } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";
import {mapState} from "vuex";

export default {
  methods: {
    getConfiguredTableHeader(table, defaultColumns){
      let configuredColumns = []
      defaultColumns.forEach((item)=>{
        item.is_hidden = false;
        configuredColumns.push(item);
      })

      let tableConfigFromApi = this.tablesConfig && this.tablesConfig.find((el)=>el.table_name===table)
      if(tableConfigFromApi && tableConfigFromApi.columns){
        configuredColumns = [];
        let areFoundColumnName = [];
        tableConfigFromApi.columns.forEach((columnFromApi)=>{
          defaultColumns.forEach((item)=>{
            let columnFromApiValue = Object.keys(columnFromApi)[0];
            if(item.value===columnFromApiValue) {
              areFoundColumnName.push(columnFromApiValue);
              item.is_hidden = ! columnFromApi[columnFromApiValue]
              configuredColumns.push(item);
            }
          })
        })
        defaultColumns.forEach((item)=>{ // если в defaultColumns есть колонки которых нет в ответе от API
          if(! areFoundColumnName.includes(item.value)){
            configuredColumns.push(item);
          }
        })
      }
      return configuredColumns;
    },
    addPartToCart(data) {
      return this.$store.dispatch("cart/addToCart", data);
    },
    validateShortDateString(date, locale='ru'){
      if(locale==='ru'){
        if(!date) return false;
        if(date.length !== '29.11.1987'.length) {
          return false;
        }
        let splitted = date.split('.')
        if(splitted.length!==3){
          return false;
        }
        let day = parseInt(splitted[0], 10);
        let month = parseInt(splitted[1], 10);
        let year = parseInt(splitted[2], 10);
        // Check the ranges of month and year
        if(year < 1900 || year > 2200 || month === 0 || month > 12)
          return false;
        let monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
        // Adjust for leap years
        if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
          monthLength[1] = 29;
        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
      } else {
        return true;
      }
      return false;
      return true;
    },
    async addDummyToCart(item) {
      let res;
      let data = {
        type: "part",
        brand: item.part.brand,
        part_number: item.part.part_code,
        name: item.part.name,
        price: 0,
        purchase_price: 0,
        supplier_name: " ",
        delivery_time: 0,
        crossed_from_brand: item.part.brand,
        crossed_from_part_number: item.part.part_code.replace(/\s/g, ""),
        goods_id: null,
        is_dummy: true,
      };
      if (item.car) {
        let existCart = this.$store.getters["cart/getField"]("carts").filter(
          (elm) => {
            return (
              elm.customer_id === item.car.customer_id &&
              elm.customer_car_id === item.car.id
            );
          }
        )[0];
        if (existCart) {
          res = await this.$store
            .dispatch("cart/setDefaultCart", existCart.id)
            .then(() => {
              return this.addPartToCart(data);
            });
        } else {
          let newCartData = {
            customer_id: item.car.customer_id,
            customer_car_id: item.car.id,
            name: item.car.name,
          };
          res = await this.$store
            .dispatch("cart/createCart", newCartData)
            .then(() => {
              return this.addPartToCart(data);
            });
        }
      } else {
        res = this.addPartToCart(data);
      }
      if (res) {
        this.$inform(this.$t("common.success_add"));
      }
    },
    goToSearchWithCustomerCar: function (
      customerCar,
      part = null,
      bid_id = null
    ) {
      let route = {
        name: "search",
      };
      if (part) {
        route.params = {
          brand: part.brand,
          search_number: part.part_code,
          search_page: 'search',
        };
      }
      let existCart = this.$store.getters["cart/getField"]("carts").filter(
        (cart) => {
          return bid_id
            ? cart.customer_id === customerCar.customer_id &&
                cart.customer_car_id === customerCar.id &&
                cart.bid_id === bid_id
            : cart.customer_id === customerCar.customer_id &&
                cart.customer_car_id === customerCar.id;
        }
      )[0];
      if (existCart) {
        this.$store.dispatch("cart/setDefaultCart", existCart.id).then(() => {
          this.$router.push(route);
        });
        return;
      }

      let data = {
        customer_id: customerCar.customer_id,
        customer_car_id: customerCar.id,
        name: customerCar.name
          ? customerCar.name
          : customerCar.brand + " " + customerCar.model,
        bid_id,
      };

      this.$store.dispatch("cart/createCart", data).then((res) => {
        if(res) this.$router.push(route);
      });
    },
    goToSearchWithCustomer: function (customer, bid_id = null) {
      let route = {
        name: "search",
      };
      let existCart = this.$store.getters["cart/getField"]("carts").filter(
        (el) => {
          return bid_id
            ? el.customer_id === customer.id &&
                parseInt(el.bid_id) === parseInt(bid_id)
            : el.customer_id === customer.id;
        }
      )[0];
      if (existCart) {
        this.$store.dispatch("cart/setDefaultCart", existCart.id).then(() => {
          this.$router.push({ name: "search" });
        });
        return;
      }

      let data = {
        customer_id: customer.id,
        customer_car_id: null,
        bid_id,
        name: customer.last_name + " " + customer.first_name,
      };

      this.$store.dispatch("cart/createCart", data).then((res) => {
        if(res) this.$router.push(route);
      });
    },

    goToSearchWithOrder: function (order_id, order_human_number, customer_id, customer_car_id = null) {
      let route = {
        name: "search",
      };
      let existCart = this.$store.getters["cart/getField"]("carts").find(
          (cart) => {
            return parseInt(cart.order_id) === parseInt(order_id);
          }
      );
      if (existCart) {
        this.$store.dispatch("cart/setDefaultCart", existCart.id).then(() => {
          this.$router.push({ name: "search" });
        });
        return;
      }

      let data = {
        customer_id: customer_id,
        customer_car_id: customer_car_id,
        order_id,
        name: "#" + order_human_number,
      };

      this.$store.dispatch("cart/createCart", data).then((res) => {
        if(res) this.$router.push(route);
      });
    },
    goToSearchWithPart(brand, part_code) {
      if(this.id==='fixedTableCart'){ //если корзина открыта в окне - эмитируем событие для закрытия

        this.$emit('close')
      }
      let route = {
        name: "search",
      };
      route.params = {
        brand: brand,
        search_page: 'search',
        search_number: part_code,
      };
      this.$router.push(route);

    },
    brandURL(brand) {
      try {
        return (
          this.brands.filter((item) => {
            return item.name.toLowerCase() === brand.toLowerCase();
          })[0].logo_small || false
        );
      } catch (e) {
        return false;
      }
    },
    async toOEMWidget(item) {
      if (item.family == "" || item.model == "") {
        this.$error("Wrong car parameters");
        return;
      }
      const globalBrandObj = this.brands.filter((br) => {
        return br.name.toUpperCase() === item.brand.toUpperCase();
      })[0];
      let catalog_code = globalBrandObj.catalog_code || null;
      const lnk = `/brand/${catalog_code}/0/${encodeURIComponent(
        item.family
      )}/${encodeURIComponent(item.model)}/${item.brand}/${
        item.levam_link
      }/ssd/universal/`;
      this.widgetHash = `#${lnk}`;
      await this.$router
        .push({ name: "search", params: { search_page: "oem" } })
        .catch((err) => {
        });
    },
    roundTimeTo15min(time) {
      let timeArr = time.split(":");
      let minutes = this.roundIntTo15(parseInt(timeArr[1]));
      if (parseInt(timeArr[1]) > 45) {
        timeArr[0]++;
        minutes = "00";
      }
      return timeArr[0] + ":" + minutes;
    },
    roundIntTo15(min) {
      let minutes = Math.ceil(min / 15) * 15;
      minutes = min <= 7 ? (minutes = 0) : minutes; //если меньше 7 округлим до 0;
      minutes = minutes > 59 ? (minutes = 0) : minutes;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      return minutes;
    },
    dateToTimestamp: function (date) {
      let year, month, day, hour, min, sec;
      year = String(date.getFullYear());
      month = String(date.getMonth() + 1);

      if (month.length == 1) {
        month = "0" + month;
      }

      day = String(date.getDate());
      if (day.length == 1) {
        day = "0" + day;
      }

      hour = String(date.getHours());
      if (hour.length == 1) {
        hour = "0" + hour;
      }

      min = String(date.getMinutes());
      if (min.length == 1) {
        min = "0" + min;
      }

      sec = String(date.getSeconds());
      if (sec.length == 1) {
        sec = "0" + sec;
      }

      return `${year}-${month}-${day} ${hour}:${min}:${sec}`;
    },
    getCorrectTextColor: function (hex) {
      /*
      From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

      Color brightness is determined by the following formula:
      ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

      I know this could be more compact, but I think this is easier to read/explain.

      */

      let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

      let hRed = hexToR(hex);
      let hGreen = hexToG(hex);
      let hBlue = hexToB(hex);

      function hexToR(h) {
        return parseInt(cutHex(h).substring(0, 2), 16);
      }
      function hexToG(h) {
        return parseInt(cutHex(h).substring(2, 4), 16);
      }
      function hexToB(h) {
        return parseInt(cutHex(h).substring(4, 6), 16);
      }
      function cutHex(h) {
        return h.charAt(0) == "#" ? h.substring(1, 7) : h;
      }

      let cBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000;
      if (cBrightness > threshold) {
        return "#000000";
      } else {
        return "#ffffff";
      }
    },
    formatCurrency(number){
      if( !(this.authenticatedUser && this.authenticatedUser.shop && this.authenticatedUser.shop.currency)){
        return number;
      }
      number = String(number).replace(/,/g, '.')
      try {
        return new Intl.NumberFormat(this.authenticatedUser.shop.currency.locale  , {
          style: 'currency',
          currency: this.authenticatedUser.shop.currency.code

        }).format(number)
      } catch (e) {
        return number +' '+(this.authenticatedUser.shop.currency.symbol || '');
      }
    },
  },
  computed: {
    ...mapFields("tables_config", ["tablesConfig", "isLoadingTablesConfig"]),
    ...mapFields("common", ["brands", "widgetHash"]),
    ...mapFields("site", ["first_day_of_week", "lang", "locale"]),
    ...mapFields("helptour", ["helpsteps", "helpcallbacks"]),
    ...mapState("auth", ["authenticated", "authenticatedUser", "isFetching"]),
    isEnabledStorageV2(){
      return process.env.VUE_APP_IS_ENABLED_STORAGE_V2 && process.env.VUE_APP_IS_ENABLED_STORAGE_V2.toLowerCase()==='true'
    },
    backendURL(){
      return process.env.VUE_APP_API_URL
    },
    currencySymbol(){
      return this.authenticatedUser && this.authenticatedUser.shop && this.authenticatedUser.shop.currency && this.authenticatedUser.shop.currency.symbol || '';
    },
    postIconPath(){
      return process.env.VUE_APP_API_ROOT+process.env.VUE_APP_POST_IMG_PREFIX;
    },
  },
};
